import * as React from 'react';
import type { SVGProps } from 'react';
const SvgUnloading = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={21} fill="none" {...props}>
    <path fill="#616061" d="M0 3.5h8v2H3v10h5v2H0z" />
    <path fill="#616061" d="M11 9.5v-3h1l4 4-4 4h-1v-3H6v-2z" />
  </svg>
);
export default SvgUnloading;
